module.exports = __webpack_public_path__ + "34a905e93abed9700b33395e099cde27.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/scientist.png
 ** module id = 1078
 ** module chunks = 0
 **/